import React, { useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Grid } from "@material-ui/core";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function ViewOrder(state) {
  const { id } = useParams();
  const [userfirstname, setuserfirstname] = useState("");
  const [userlastname, setuserlastname] = useState("");
  const [usermobilenumber, setmobilenumber] = useState("");
  const [useridnumber, setidnumber] = useState("");
  const [usercity, setcity] = useState("");
  const [userzone, setzone] = useState("");
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/order/${id}`,
        { withCredentials: true }
      )
      .then((res) => {
        setuserfirstname(res.data.data.original.from_staff_name);
        setuserlastname(res.data.data.original.amount);
        setmobilenumber(res.data.data.original.order_type);
        setidnumber(res.data.data.original.status_type);
        setcity(res.data.data.original.fund_name);
        setzone(res.data.data.original.fund_company);
      })
      .catch((err) => {});
  }, []);

  return (
    <div className="main-div">
      <Grid container spacing={2} className="user-info">
        <img className="user-img" src="../profile.svg" alt="user-img"></img>
        <h3>{userfirstname}</h3>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={12} xs={12}>
          <div className="userdetails">
            <div className="userdetailsborder">
              <h3>استعراض الطلبيات </h3>
            </div>
            <table className="table">
              <tr>
                <th>اسم الموزع</th>
                <td>{userfirstname}</td>
                <th> كمية الرصيد</th>
                <td>{userlastname}</td>
              </tr>
              <tr>
                <th> نوع الطلب </th>
                <td>{usermobilenumber}</td>
                <th>نوع الرصيد</th>
                <td>{useridnumber}</td>
              </tr>
              <tr>
                <th>اسم الشركة</th>
                <td>{userzone}</td>
                <th>اسم الرصيد</th>
                <td>{usercity}</td>
              </tr>
            </table>
          </div>
        </Grid>
        <Grid item xs={8}></Grid>
      </Grid>

      <div></div>
    </div>
  );
}
